"use strict";

angular.module('createOriginalGroupModule',[])
    .controller('createOriginalGroupCtrl',['$scope', '$modalInstance', 'trsHttpService','modalDialog','originalParams', '$q',
    function($scope, $modalInstance, trsHttpService, modalDialog, originalParams, $q){
        initStatus();
        initTitle();
        initData();
        function initData(){
            if(originalParams.type=='modify'&&originalParams.pageNum==2){
                initList().then(function(){
                    initSelect();
                })
            }
        }
        function initTitle(){
            if(originalParams.type=='create')
                $scope.data.title = '新增';
            else if(originalParams.pageNum==1)
                $scope.data.title = '修改分组名称';
            else
                $scope.data.title = '修改'+originalParams.item.GROUPNAME+'的产品';
        }
        $scope.initTabs = function(type){
            return $scope.data.allItems.find((item_)=>{
                if(item_.MEDIATYPE == type){
                    return item_.PRODUCTS.length!=0;
                }
            })
        }
        function initStatus(){
            $scope.status = {
                page: originalParams.pageNum,
                selectedTab:3,
                keyword: '',
                type: originalParams.type,
                item: originalParams.item,
            };
            $scope.data = {
                title:'',
                GROUPNAME: $scope.status.item ? $scope.status.item.GROUPNAME : '',
                items: [],
                selectedItems: [],
                allItems: [],
            }
            $scope.channelType = ['客户端','网站','纸媒','微信','微博'];
        }
        $scope.next = function(){
            checkNameIsUsed().then(function(){
                $scope.status.page++;
                if(originalParams.type=='create')
                    $scope.data.title = '选择产品';
                else{
                    $scope.data.title = '修改'+$scope.data.GROUPNAME+'的产品';
                    initSelect();
                }
                initList();
            });
        }
        $scope.cancel = function(){
            $modalInstance.close('fail');
        }
        $scope.switch = function(type){//1:app,2:website,3:newspaper,4:wechat,5:weibo
            $scope.status.selectedTab = type;
            getListByMediaType(type);
        }
        function initSelect(){
            $scope.data.selectedItems = [];
            if($scope.status.item.PRODUCTIDS){
                let ids = $scope.status.item.PRODUCTIDS.split(',');
                ids = ids.filter(function(val){
                    return !!val;
                });
                let names = $scope.status.item.PRODUCTNAME.split(',');
                names = names.filter(function(val){
                    return !!val;
                });
                let types = {
                    '纸媒': 3,
                    '网站': 2,
                    '客户端': 1,
                    '微信': 4,
                    '微博':5
                };
                angular.forEach(ids,function(id,index){
                    let type = names[index].split('-')[0];
                    type = types[type];
                    let list = $scope.data.allItems[type-1].PRODUCTS;
                    angular.forEach(list,function(value){
                        if(value.CANOPERATION){
                            if(value.CANOPERATION.productid == parseInt(id)){
                                let item = {
                                    productId: value.CANOPERATION.productid,
                                    productName: value.CANOPERATION.productname,
                                    isUsed: false,
                                    mediaType: type
                                };
                                $scope.data.selectedItems.push(item);
                            }
                        }
                        if(value.NOOPERATION){
                            if(value.NOOPERATION.productid == parseInt(id)){
                                let item = {
                                    productId: value.NOOPERATION.productid,
                                    productName: value.NOOPERATION.productname,
                                    isUsed: true,
                                    mediaType: type
                                };
                                $scope.data.selectedItems.push(item);
                            }
                        }
                    })
                });
                
            }
        }
        function initList(){
            $scope.data.allItems = [];
            let deffer = $q.defer();
            let params = {
                serviceid: 'mlf_originalgroup',
                methodname: 'queryWebsiteProducts',
                MEDIATYPE: '',
                ORIGINALGROUPID: $scope.status.item ? $scope.status.item.ORIGINALGROUPID : 0,
                keyword: ''
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),params,'get').then(function(data){
                if(data){
                    $scope.data.allItems = data;
                    let types = [3,2,1,4,5];
                    let type = 3;
                    for(var i=0;i<types.length;i++){
                        if($scope.initTabs(types[i])){
                            type = types[i];
                            break;
                        }
                    }
                    $scope.status.selectedTab = type;
                    getListByMediaType(type);
                }
                deffer.resolve();
            });
            return deffer.promise;
        }
        function getListByMediaType(type){
            let items = [];
            $scope.data.items = [];
            angular.forEach($scope.data.allItems,function(value,index){
                if(value.MEDIATYPE == type){
                    items = value.PRODUCTS;
                }
            });
            angular.forEach(items,function(value){
                if(value.CANOPERATION){
                    let item = {
                        productId: value.CANOPERATION.productid,
                        productName: value.CANOPERATION.productname,
                        isUsed: false,
                        mediaType: type
                    };
                    $scope.data.items.push(item);
                }
                if(value.NOOPERATION){
                    let item = {
                        productId: value.NOOPERATION.productid,
                        productName: value.NOOPERATION.productname,
                        isUsed: true,
                        mediaType: type
                    };
                    $scope.data.items.push(item);
                }
            });
        }
        function getList(){
            $scope.data.items = [];
            let params = {
                serviceid: 'mlf_originalgroup',
                methodname: 'queryWebsiteProducts',
                MEDIATYPE: $scope.status.selectedTab,
                ORIGINALGROUPID: $scope.status.item ? $scope.status.item.ORIGINALGROUPID : 0,
                keyword: $scope.status.keyword,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),params,'get').then(function(data){
                angular.forEach(data,function(value){
                    if(value.CANOPERATION){
                        let item = {
                            productId: value.CANOPERATION.productid,
                            productName: value.CANOPERATION.productname,
                            isUsed: false,
                            mediaType: $scope.status.selectedTab
                        };
                        $scope.data.items.push(item);
                    }
                    if(value.NOOPERATION){
                        let item = {
                            productId: value.NOOPERATION.productid,
                            productName: value.NOOPERATION.productname,
                            isUsed: true,
                            mediaType: $scope.status.selectedTab
                        };
                        $scope.data.items.push(item);
                    }
                })
            });
        }
        $scope.singleSelect = function(item){
            if(item.isUsed) return;
            let index = $scope.data.selectedItems.findIndex((item_)=>{
                return item_.productId == item.productId;
            })
            if(index > -1)
                $scope.data.selectedItems.splice(index,1);
            else
                $scope.data.selectedItems.push(item);
        }
        $scope.isSelected = function(item){
            return $scope.data.selectedItems.find((item_)=>{
                return item_.productId == item.productId;
            });
        }
        $scope.reset = function(){
            initSelect();
            $scope.status.keyword = '';
        }
        function getProducts(){
            let products = [];
            angular.forEach($scope.data.selectedItems,function(item){
                let item_ = {
                    "MEDIATYPE": item.mediaType,
                    "PRODUCTID": item.productId
                }
                products.push(item_);
            });
            return JSON.stringify(products);
        }
        function save(){
            let flag = originalParams.type=='create';
            modalDialog.alertType(flag ? "确定创建分组？":"确定修改分组？","","ask",true,function(){
                if(flag||$scope.status.page==1){
                    let params = {
                        serviceid: 'mlf_originalgroup',
                        methodname: 'saveOriginalGroup',
                        ORIGINALGROUPID: $scope.status.item ? $scope.status.item.ORIGINALGROUPID:0,
                        GROUPNAME: $scope.data.GROUPNAME,
                        products: getProducts(),
                    }
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),params,'get').then(function(){
                        modalDialog.alertType(flag ?"新建分组成功！":"修改分组成功！","","success",false, function(){
                            $modalInstance.close('success');
                        });
                    })
                }
                else{
                    let params = {
                        serviceid: 'mlf_originalgroup',
                        methodname: 'updateGroupProducts',
                        ORIGINALGROUPID: $scope.status.item.ORIGINALGROUPID,
                        products: getProducts(),
                    }
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),params,'get').then(function(){
                        modalDialog.alertType("修改分组成功！","","success",false, function(){
                            $modalInstance.close('success');
                        });
                    });
                }
            });
        }
        $scope.save = function(){
            if($scope.status.page==1){
                checkNameIsUsed().then(function(){
                    save();
                });
            }
            else
                save();
        }
        $scope.remove = function(item){
            let index = $scope.data.selectedItems.findIndex((item_)=>{
                return item_.productId == item.productId;
            })
            $scope.data.selectedItems.splice(index,1);
        }
        $scope.search = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                if($scope.status.keyword){
                    getList();
                }
                else{
                    getListByMediaType($scope.status.selectedTab);
                }
            }
        };
        function checkNameIsUsed(){
            let defer = $q.defer();
            let params = {
                serviceid: 'mlf_originalgroup',
                methodname: 'queryOriginalGroupName',
                GROUPNAME: $scope.data.GROUPNAME,
                ORIGINALGROUPID: $scope.status.item ? $scope.status.item.ORIGINALGROUPID : 0,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(),params,'get').then(function(data){
                defer.resolve();
            })
            return defer.promise;
        }
    }]);